import React, { useEffect, useState } from "react";
import ItemExpandTable from "./ItemExpandTable";
import changeItemStatus from "../api/changeItemStatus";
import ItemExpandAdding from "./ItemExpandAdding";
import ItemExpandUpdatingPicture from "./ItemExpandUpdatingPicture";
import AlertComponent from "../../../components/AlertComponent";
import ErrorAlert from "../../../components/ErrorAlert";

const ItemRow = ({ child }) => {
  const [errorAlert, setErrorAlert] = useState(false);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [itemName, setItemName] = useState("");
  const [expandedItemId, setExpandedItemId] = useState(null);
  const [expandedItemIdAdding, setExpandedItemIdAdding] = useState(null);
  const [expandingPicture, setExpandingPicture] = useState(null);
  const [imageVersion, setImageVersion] = useState(Date.now());
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const openConfirmationModal = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setShowConfirmationModal(true);
  };
  const closeConfirmationModal = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setShowConfirmationModal(false);
  };

  const handleChangeItemStatus = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    const statusChanged = await changeItemStatus({ itemId: child.id, itemStatus: "2" });
    if (statusChanged) {
      setDeleteAlert(true);
      setErrorAlert(false);
    } else {
      setErrorAlert(true);
      setDeleteAlert(false);
    }
    closeConfirmationModal();
  };

  // Function to toggle the expandable row for a specific order
  const toggleExpand = (itemId) => {
    if (expandedItemId === itemId) {
      setExpandedItemId(null); // Collapse the row if it's already expanded
    } else {
      setExpandedItemId(itemId);
      setExpandedItemIdAdding(null);
      setExpandingPicture(null);
    }
  };

  const toggleExpandPicture = (itemId) => {
    if (expandingPicture === itemId) {
      setExpandingPicture(null); // Collapse the row if it's already expanded
    } else {
      setExpandingPicture(itemId);
      setExpandedItemIdAdding(null);
    }
  };

  // for adding toggle

  // Function to toggle the expandable row for a specific order
  const toggleExpandAdding = (itemId) => {
    if (expandedItemIdAdding === itemId) {
      setExpandedItemIdAdding(null);
    } else {
      setExpandedItemIdAdding(itemId);
      setExpandedItemId(null);
      setExpandingPicture(null);
    }
  };

  // set Item Name
  useEffect(() => {
    setItemName(child.name);
  }, [child][child.image]);
  return (
    <>
      {errorAlert ? (
        <ErrorAlert
          title={"فشل تحديث المعلومات"}
          content={"يرجى التأكد من إدخال معلومات صحيحة والمحاولة مرة أخرى لاحقا"}
        />
      ) : (
        ""
      )}
      {deleteAlert ? (
        <AlertComponent
          title={"تم حذف المنتج بنجاح"}
          content={`تمت حذف المنتج بإسم  ${child.name}  بنجاح`}
        />
      ) : (
        ""
      )}
      <tr className="bg-gray-100 border-b">
        <td className="px-6 py-4">
          <button
            className="text-red-500 hover:text-red-700 font-bold text-md"
            onClick={() => openConfirmationModal()}
          >
            حذف
          </button>
          {showConfirmationModal && (
            <div className="modal-overlay">
              <div className="modal-content">
                <p>هل أنت متأكد من أنك تريد حذف هذا المنتج؟</p>
                <button
                  onClick={handleChangeItemStatus}
                  className=" my-2 w-32 px-3 py-2 text-sm font-medium text-center text-white bg-red-700 rounded-lg hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300"
                >
                  نعم
                </button>

                <button
                  onClick={closeConfirmationModal}
                  className=" my-2 w-32 px-3 py-2 text-sm font-medium text-center text-white bg-red-700 rounded-lg hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300"
                >
                  لا
                </button>
              </div>
            </div>
          )}
        </td>
        <td className="px-6 py-4">
          <button
            className="text-blue-500 hover:text-blue-700"
            onClick={() => toggleExpand(child.id)}
          >
            {expandedItemId ? "إخفاء" : "عرض التفاصيل"}
          </button>
        </td>
        <td className="px-6 py-4 text-blue-500 hover:text-blue-700 font-bold text-md">
          <button
            className="text-blue-500 hover:text-blue-700 mr-2 flex items-center"
            onClick={() => toggleExpandAdding(child.id)}
          >
            إضافة منتج جديد
          </button>
        </td>
        <td className="px-6 py-4">
          <button
            className="text-blue-500 hover:text-blue-700 font-bold text-md"
            onClick={() => toggleExpandPicture(child.id)}
          >
            {expandingPicture ? "إخفاء" : "تعديل"}
          </button>
        </td>

        {/* <td className="px-6 py-4">
          <input type="checkbox" name="moresale" />
        </td>  */}

        <th scope="row" className="px-6 text-gray-900 whitespace-nowrap text-right">
          <input
            type="text"
            name="name"
            className="py-2 px-2 rounded text-sm w-full"
            value={itemName}
            readOnly
            dir="rtl"
          />
        </th>
        <th className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap flex items-center justify-center">
          {child.image ? (
            <img
              src={`${process.env.REACT_APP_IMAGE_URL}/${child.image}.png?v=${imageVersion}`}
              alt="Item "
              className="w-16 h-16 object-cover object-center"
            />
          ) : (
            ""
          )}
        </th>
      </tr>
      {expandingPicture === child.id ? (
        <ItemExpandUpdatingPicture
          item={child}
          onImageUpdated={() => setImageVersion(Date.now())}
          showAllFields={false}
        />
      ) : (
        ""
      )}
      {expandedItemId === child.id ? <ItemExpandTable item={child} /> : ""}
      {expandedItemIdAdding === child.id ? <ItemExpandAdding child={child} /> : ""}
    </>
  );
};

export default ItemRow;
